import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import { Page, PageHeader, PageContent } from '@bliks-io/ui';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { ContentHeader } from '@/components/content-header';
import { DataSyncSettings } from '@/pages/organization-settings/data-sync/DataSyncSettings';

export function DataSyncPage() {
  const { t } = useTranslation();
  useDocumentTitle('pageTitles.dataSync');

  return (
    <Page>
      <PageHeader />
      <PageContent>
        <ContentHeader icon={RefreshCw} title={t('dataSync.settings.title')} />
        <div className="mt-8">
          <DataSyncSettings />
        </div>
      </PageContent>
    </Page>
  );
}
